__turbopack_context__.v({
  "icon": "ShowMoreButton-module__NCxo5G__icon",
  "showMoreButton": "ShowMoreButton-module__NCxo5G__showMoreButton",
});
